export default "__VITE_PUBLIC_ASSET__f8f73815__"